import styled from 'styled-components';

const TituloAreas = styled.h1`
    text-transform: uppercase;
    font-weight: bold;
    margin: 15px auto;
    text-align: center;
    margin: 15px 0;
`;

export default TituloAreas;
